import type { BrandShellConfig } from "../base/BrandShell";

import { WIFIBOT_PROOFS } from "./proofs";
import { WifibotLogo } from "./WifibotLogo";

// Inline SVG turbulence noise; opacity/blend applied in CSS. `<`/`>` and the
// literal `%` are percent-encoded so the data URI stays valid.
const GRAIN =
  "url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

// Illustrative NOC telemetry for the terminal scene — fictional, no real
// client/device data. Rendered twice so the scroll loops seamlessly.
const TELEMETRY = [
  "NOC · uplink OK    rx -18.2 dBm",
  "ont 38,654   ap 10,648   switch 3,201",
  "alert · resolved    00:03",
  "poll cycle · 71 tenants   ok",
  "signal 5GHz   rssi -52   rate 866",
  "inventory · +2 devices auto-documented",
];

/**
 * WiFiBot: two motifs that cross-fade in a loop — a WiFi signal field and a
 * scrolling NOC telemetry terminal — on navy-black. Reduced motion freezes on
 * the signal scene (see wifibot.css). The form follows the system theme.
 */
export const WIFIBOT_SHELL: BrandShellConfig = {
  testId: "wb-shell",
  art: (
    <>
      <div className="wb-scenes" aria-hidden="true">
        <div className="wb-scene wb-scene--signal">
          <span className="wb-glow" />
          <span className="wb-arc" style={{ animationDelay: "0s" }} />
          <span className="wb-arc" style={{ animationDelay: "1.2s" }} />
          <span className="wb-arc" style={{ animationDelay: "2.4s" }} />
          <span className="wb-core" />
        </div>
        <div className="wb-scene wb-scene--telemetry">
          <pre className="wb-telemetry">
            {[...TELEMETRY, ...TELEMETRY].join("\n")}
          </pre>
          <svg
            className="wb-wave"
            viewBox="0 0 340 44"
            preserveAspectRatio="none"
          >
            <polyline
              points="0,22 30,20 45,8 60,30 90,18 120,24 145,6 175,28 205,14 240,24 275,12 305,22 340,18"
              fill="none"
              strokeWidth={1.5}
            />
          </svg>
        </div>
      </div>
      <div
        className="wb-grain"
        aria-hidden="true"
        style={{ backgroundImage: GRAIN }}
      />
    </>
  ),
  logo: (compact) => <WifibotLogo height={compact ? 22 : 28} />,
  eyebrow: "NETWORK OPERATIONS",
  proofs: WIFIBOT_PROOFS,
  home: { href: "https://wifibot.ai/", label: "Back to wifibot.ai" },
};
